module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand2_m_jp.0e7253df499e0b12f8e7a6f3816fc861.png";